import { render } from "./PersonalWebsite.vue?vue&type=template&id=e3a4bd40"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__